import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getIsUserAnAdmin } from '../../UserData/userDataEntity';
import RoutingRules from './RoutingRules/RoutingRules';
import { getIsLoading as getIsUserLoading } from '../../Self/selfEntity';

export class UserRoutingRules extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isUserLoading: PropTypes.bool
    };

    render() {
        if (!this.props.isAdmin && !this.props.isUserLoading) {
            return (<div className="emvio-routing-rules">
                Insufficient access rights to manage payment routing rules.
            </div>);
        }

        return (<div className="emvio-routing-rules">
            <RoutingRules />
        </div>);
    }
}

export function mapStateToProps(state) {
    return {
        isAdmin: getIsUserAnAdmin(state),
        isUserLoading: getIsUserLoading(state)
    };
}

export default connect(mapStateToProps)(UserRoutingRules);
